var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 2.5H47C44.9289 2.5 43.25 4.17893 43.25 6.25V25C43.25 27.0711 44.9289 28.75 47 28.75H65.75C67.8211 28.75 69.5 27.0711 69.5 25V6.25C69.5 4.17893 67.8211 2.5 65.75 2.5Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 70V21.25C28.25 20.2554 27.8549 19.3016 27.1516 18.5984C26.4484 17.8951 25.4946 17.5 24.5 17.5H5.75C4.75544 17.5 3.80161 17.8951 3.09835 18.5984C2.39509 19.3016 2 20.2554 2 21.25V66.25C2 67.2446 2.39509 68.1984 3.09835 68.9017C3.80161 69.6049 4.75544 70 5.75 70H50.75C51.7446 70 52.6984 69.6049 53.4017 68.9017C54.1049 68.1984 54.5 67.2446 54.5 66.25V47.5C54.5 46.5054 54.1049 45.5516 53.4017 44.8484C52.6984 44.1451 51.7446 43.75 50.75 43.75H2",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDark);
export default __webpack_public_path__ + "static/media/OpenDark.0f00bb5cb1500a32363b585fb15eb975.svg";
export { ForwardRef as ReactComponent };